
import React from "react";
import { LinkInBioProfile, CustomLink } from "@/types/linkinbio";
import { ProfileSection } from "./ProfileSection";
import { LinksSection } from "./LinksSection";
import { AppearanceSection } from "./AppearanceSection";
import { LinkAnalytics } from "./LinkAnalytics";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface LinkInBioEditorProps {
  profile: LinkInBioProfile;
  onProfileUpdate: (profile: Partial<LinkInBioProfile>) => void;
  onAddLink: () => void;
  onUpdateLink: (link: CustomLink) => void;
  onRemoveLink: (linkId: string) => void;
  onReorderLinks: (links: CustomLink[]) => void;
}

export const LinkInBioEditor: React.FC<LinkInBioEditorProps> = ({
  profile,
  onProfileUpdate,
  onAddLink,
  onUpdateLink,
  onRemoveLink,
  onReorderLinks,
}) => {
  return (
    <Tabs defaultValue="profile">
      <TabsList className="mb-6 w-full">
        <TabsTrigger value="profile" className="flex-1">Profile</TabsTrigger>
        <TabsTrigger value="links" className="flex-1">Links</TabsTrigger>
        <TabsTrigger value="appearance" className="flex-1">Appearance</TabsTrigger>
        <TabsTrigger value="analytics" className="flex-1">Analytics</TabsTrigger>
      </TabsList>
      
      <TabsContent value="profile">
        <ProfileSection 
          profile={profile} 
          onProfileUpdate={onProfileUpdate} 
        />
      </TabsContent>
      
      <TabsContent value="links">
        <LinksSection 
          links={profile.customLinks}
          socialLinks={profile.socialLinks}
          onAddLink={onAddLink}
          onUpdateLink={onUpdateLink}
          onRemoveLink={onRemoveLink}
          onReorderLinks={onReorderLinks}
          onSocialLinksUpdate={(socialLinks) => onProfileUpdate({ socialLinks })}
        />
      </TabsContent>
      
      <TabsContent value="appearance">
        <AppearanceSection 
          profile={profile}
          onProfileUpdate={onProfileUpdate}
        />
      </TabsContent>
      
      <TabsContent value="analytics">
        <LinkAnalytics 
          links={profile.customLinks}
        />
      </TabsContent>
    </Tabs>
  );
};
